import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {
  TenantsClient,
  UserResponse,
  UsersClient,
  UserUpdateRequest
} from '../../../generated-client/generated-api-client';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {FormGroup} from '@angular/forms';
import {TenantService} from "../../../services/tenant.service";
import {isFormModifiedDataService} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.sass'],
})
export class UserEditComponent implements OnInit {
  id: string;
  response!: Observable<UserResponse>;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private router: Router,
    private client: UsersClient,
    private errorProcessorService: ErrorProcessorService,
    private tenantService: TenantService,
    private tenantClient: TenantsClient,
    private _isFormModifiedDataService: isFormModifiedDataService
  ) {
    this.id = '';
    this.titleService.setTitle('Felhasználó módosítása');
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get('id') ?? '';
    });
  }

  ngOnInit(): void {
    this.response = this.client.get(this.id);
  }

  async onSubmit(form: FormGroup): Promise<void> {
    const request: UserUpdateRequest = {
      id: form.get('id')?.value === '' ? null : form.get('id')?.value,
      title: form.get('title')?.value === '' ? null : form.get('title')?.value,
      email: form.get('email')?.value === '' ? null : form.get('email')?.value,
      surname: form.get('surname')?.value === '' ? null : form.get('surname')?.value,
      forename: form.get('forename')?.value === '' ? null : form.get('forename')?.value,
      forename2: form.get('forename2')?.value === '' ? null : form.get('forename2')?.value,
      idNumber: form.get('idNumber')?.value === '' ? null : form.get('idNumber')?.value,
      roles: form.get('roles')?.value === '' ? null : form.get('roles')?.value,
      tenantIds: form.get('tenantIds')?.value === '' ? null : form.get('tenantIds')?.value,
      twoFactorEnabled: form.get('twoFactorEnabled')?.value,
    };
    const response = await this.client.edit(request);
    response.subscribe(
      next => {
        this.tenantService.refreshTenantSelectList(this.tenantClient);
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate(['/users']);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
